import React from 'react';
import { AppInsightsContext, ReactPlugin } from '@microsoft/applicationinsights-react-js';
import serviceLogger from './services/logging/service-logger';
import { AadProvider } from './providers/aad/provider-aad';
import { SelexpProvider } from './providers/selexp/provider-selexp';
import SellerExperience from './seller-experience';
import { ErrorBoundary } from './services/logging/component-error-boundary';
import { TrackEngagement } from './services/logging/component-track-engagement';

const MemoSellerExp = React.memo(SellerExperience);
export const MEMBootstrap = () => (
  <ErrorBoundary>
    <AppInsightsContext.Provider value={serviceLogger.reactPlugin as ReactPlugin}>
      <AadProvider>
        <SelexpProvider>
          <TrackEngagement componentName="Seller Experience">
            <MemoSellerExp />
          </TrackEngagement>
        </SelexpProvider>
      </AadProvider>
    </AppInsightsContext.Provider>
  </ErrorBoundary>
);
